module.exports = __webpack_public_path__ + "media/images/guaranteed-guest-list-access-79000f9e8f8c6c4e4f766afd4a484165.svg";